import { FluidTheme } from '@lmig/fluid-core';

import { FluidIconRef } from '../../components/fluid-icon/components/fluid-icon.components';
import { LegacyIcons } from './legacy.icons';
import { LMIcons } from './lm.icons';

export const iconThemeMap: Record<string, Record<string, FluidIconRef>> = {
  default: LMIcons,
  legacy: LegacyIcons,
  lm: LMIcons,
  corp: LMIcons,
  portal: LMIcons,
};

export const loadIcon = (iconKey: string, theme: string): FluidIconRef => {
  if (!theme) {
    theme = FluidTheme.CORP;
  }
  return iconThemeMap[theme][iconKey];
};
